// import performer from "@frog/source/utility/gl/render.js"

const palettes = {
    "red": {
        "colors": [
            {
                "r": 128,
                "g": 160,
                "b": 128,
                "a": 0
            },
            {
                "r": 104,
                "g": 72,
                "b": 96
            },
            {
                "r": 192,
                "g": 168,
                "b": 184
            },
            {
                "r": 224,
                "g": 224,
                "b": 224
            },
            {
                "r": 112,
                "g": 96,
                "b": 96
            },
            {
                "r": 176,
                "g": 144,
                "b": 88
            },
            {
                "r": 248,
                "g": 248,
                "b": 208
            },
            {
                "r": 96,
                "g": 40,
                "b": 32
            },
            {
                "r": 168,
                "g": 48,
                "b": 40
            },
            {
                "r": 224,
                "g": 16,
                "b": 16
            },
            {
                "r": 248,
                "g": 80,
                "b": 72
            },
            {
                "r": 56,
                "g": 208,
                "b": 48
            },
            {
                "r": 248,
                "g": 248,
                "b": 64
            },
            {
                "r": 128,
                "g": 136,
                "b": 112
            },
            {
                "r": 248,
                "g": 248,
                "b": 248
            },
            {
                "r": 64,
                "g": 56,
                "b": 56
            }
        ]
    },
    "blue": {
        "colors": [
            {
                "r": 128,
                "g": 160,
                "b": 128,
                "a": 0
            },
            {
                "r": 88,
                "g": 72,
                "b": 120
            },
            {
                "r": 144,
                "g": 184,
                "b": 232
            },
            {
                "r": 216,
                "g": 232,
                "b": 240
            },
            {
                "r": 112,
                "g": 96,
                "b": 96
            },
            {
                "r": 176,
                "g": 144,
                "b": 88
            },
            {
                "r": 248,
                "g": 248,
                "b": 208
            },
            {
                "r": 56,
                "g": 56,
                "b": 144
            },
            {
                "r": 56,
                "g": 80,
                "b": 224
            },
            {
                "r": 40,
                "g": 160,
                "b": 248
            },
            {
                "r": 24,
                "g": 240,
                "b": 248
            },
            {
                "r": 232,
                "g": 16,
                "b": 24
            },
            {
                "r": 248,
                "g": 248,
                "b": 64
            },
            {
                "r": 128,
                "g": 136,
                "b": 112
            },
            {
                "r": 248,
                "g": 248,
                "b": 248
            },
            {
                "r": 64,
                "g": 56,
                "b": 56
            }
        ]
    }
}
Object.keys(palettes).forEach((paletteKey) => {
    const palette = palettes[paletteKey]
    palette.colors.forEach((color) => {
        color.L = getLightness(color)
    })
    palette.colors.sort((a, b) => a.L - b.L)
})

function getLightness(color) {
    const REC601_LUMA_COEFFICIENTS = {
        "r": 0.299,
        "g": 0.587,
        "b": 0.114,
    }
    return (REC601_LUMA_COEFFICIENTS.r * color.r
        + REC601_LUMA_COEFFICIENTS.g * color.g
        + REC601_LUMA_COEFFICIENTS.b * color.b)
}

function areSameColor(a, b) {
    return a.r == b.r
        && a.g == b.g
        && a.b == b.b
}

function getColorAtIndex(array, index) {
    return {
        "r": array[index + 0],
        "g": array[index + 1],
        "b": array[index + 2],
        "a": array[index + 3],
    }
}

function setColorAtIndex(array, index, color) {
    array[index + 0] = color.r ?? 0
    array[index + 1] = color.g ?? 0
    array[index + 2] = color.b ?? 0
    array[index + 3] = color.a ?? 255
}

// const canvasGL = document.createElement("canvas")
// canvasGL.context = canvasGL.getContext("webgl2")
// performer.start(canvasGL)

export default function PaletteSwapped({imageElement, paletteKey, colors}) {
    if(imageElement == undefined) return undefined
    if(imageElement.isLoaded != true) return undefined

    if(colors == undefined && paletteKey == undefined) return undefined
    if(paletteKey != undefined && palettes[paletteKey] == undefined) return undefined
    const palette = {}
    if(paletteKey != undefined) {
        palette.colors = palettes[paletteKey].colors
    }
    if(colors != undefined) {
        colors.forEach((color) => {
            color.L = getLightness(color)
        })
        colors.sort((a, b) => a.L - b.L)
        palette.colors = colors
    }

    const canvas = document.createElement("canvas")
    canvas.context = canvas.getContext("2d")
    canvas.width = imageElement.width
    canvas.height = imageElement.height

    canvas.context.drawImage(imageElement, 0, 0)
    // performer.clear()
    // performer.render({
    //     "image": imageElement,
    // })

    //if(paletteKey == "blue") return canvas.toDataURL()

    const pixels = canvas.context.getImageData(0, 0, canvas.width, canvas.height)
    for(let index = 0; index < pixels.data.length; index += 4) {
        const sampledColor = getColorAtIndex(pixels.data, index)
        if(sampledColor.a == 0) continue
        const sampledLightness = getLightness(sampledColor)
        var interpolatedColor

        const gradientIndex = palette.colors.findIndex((color) => color.L > sampledLightness)
        if(gradientIndex == -1) {
            interpolatedColor = palette.colors[palette.colors.length - 1]
        } else if(gradientIndex == 0) {
            interpolatedColor = palette.colors[0]
        } else {
            const lighterStop = palette.colors[gradientIndex]
            const darkerStop = palette.colors[gradientIndex - 1]
            if(darkerStop == undefined) console.error("No darker color exists in gradient for palette swap", darkerStop, gradientIndex - 1)
            if(lighterStop == undefined) console.error("No lighter color exists in gradient for palette swap", lighterStop, gradientIndex)
            const percentageBetweenStops = (lighterStop.L - sampledLightness) / (lighterStop.L - darkerStop.L)
            interpolatedColor = {
                "r": percentageBetweenStops * lighterStop.r + (1 - percentageBetweenStops) * darkerStop.r,
                "g": percentageBetweenStops * lighterStop.g + (1 - percentageBetweenStops) * darkerStop.g,
                "b": percentageBetweenStops * lighterStop.b + (1 - percentageBetweenStops) * darkerStop.b,
            }
        }

        setColorAtIndex(pixels.data, index, interpolatedColor)
    }
    canvas.context.putImageData(pixels, 0, 0)

    return canvas.toDataURL()
}
